/* @ngInject */
function SharedPacksHeaderController ($scope) {
  $scope.handleOnChangeSort = (columnName) => {
    $scope.onChangeSort({ $event: columnName })
  }

  const api = {
    activate,
    _setColumns
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._setColumns()
  }

  function _setColumns () {
    if ($scope.viewMode === 'ADMIN') {
      $scope.columns = [
        { name: 'title', titleKey: 'title', sortable: true },
        { name: 'status', titleKey: 'status', sortable: false },
        { name: 'accessExpirationDate', titleKey: 'expiresOn', sortable: true },
        { name: 'createdAt', titleKey: 'createdIn', sortable: true },
        { name: 'actions', titleKey: 'actions', sortable: false }
      ]
    } else {
      $scope.columns = [
        { name: 'title', titleKey: 'title', sortable: false },
        { name: 'status', titleKey: 'status', sortable: false },
        { name: 'accessExpirationDate', titleKey: 'expiresOn', sortable: false },
        { name: 'actions', titleKey: 'actions', sortable: false }
      ]
    }
  }
}

export { SharedPacksHeaderController }
